import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { RecipientType } from '@40seas/entities/notifications';
import { z } from 'zod';

export const EmailRecipientsProviderPayloadSchema = z.object({
    emails: z.array(z.string()),
    type: EnumSchema(RecipientType),
});

export class EmailRecipientsProviderPayload extends FromSchema(EmailRecipientsProviderPayloadSchema) {
    emails: string[];
    type: RecipientType; // Primary/Secondary for output recipent types
}
